module.exports = __webpack_public_path__ + "img/horizontal_3_1_8023.b7f38435.png";